import { NetworkViewerIcon } from 'components/Graph/icons/NetworkViewerIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const NetworkViewerEmptyContent: FC = () => {
  const msg = useLocale();
  return (
    <>
      <p className='text-bold text-uppercase'>
        <NetworkViewerIcon
          title={null}
          className='mr-2.5 align-baseline inline'
          variant='coloredDark'
          width='16'
          height='16'
        />
        {msg.canvasGraph.emptyGraph.networkViewer.title}
      </p>
      <p>{msg.canvasGraph.emptyGraph.networkViewer.description}</p>
    </>
  );
};
